import Label from "lib/Label";
import "./index.scss";
import { useSelector } from "react-redux";
import { Multiselect } from "multiselect-react-dropdown";
const DashBoardMultiDropdown = (props) => {
  const {
    options,
    label,
    web_grid_col,
    mobile_grid_col,
    onChange,
    placeholder,
    name,
    value: userValue,
    class_name,
    togglecopy,
    togglesublable,
    error,
    copyToClipboard,
    selectedData,
    setSelectedData,
    size,
  } = props;
  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : "";
  const isToggled = useSelector((state) => state.formData.isToggled);
  return (
      <div className={class_name + ' ' + size}>
          <Label
              label={label}
              togglecopy={togglecopy}
              togglesublabel={togglesublable}
              copyToClipboard={copyToClipboard}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
          />
          <Multiselect
              hidePlaceholder="true"
              avoidHighlightFirstOption="true"
              customCloseIcon={

                  <div className="ps-3 cursor-pointer">
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="9.414"
                          height="9.414"
                          viewBox="0 0 9.414 9.414"
                      >
                          <g
                              id="Group_33254"
                              data-name="Group 33254"
                              transform="translate(0.707 0.707)"
                          >
                              <line
                                  id="Line_1684"
                                  data-name="Line 1684"
                                  x2="8"
                                  y2="8"
                                  transform="translate(0)"
                                  fill="none"
                                  stroke="#9a9a9a"
                                  stroke-linecap="round"
                                  stroke-width="1"
                              />
                              <line
                                  id="Line_1685"
                                  data-name="Line 1685"
                                  x1="8"
                                  y2="8"
                                  transform="translate(0)"
                                  fill="none"
                                  stroke="#9a9a9a"
                                  stroke-linecap="round"
                                  stroke-width="1"
                              />
                          </g>
                      </svg>
                  </div>
              }
              style={{
                  chips: {
                      background: '#F0EFEF',
                      color: '#4D4747',
                      fontSize: '14px',
                      borderRadius: 0
                  },
                  multiselectContainer: {
                      color:'#52575D',
                      fontSize:'14px',
                  },
                  optionContainer:{
                    border:'0px',
                    boxShadow: '0px 10px 20px #C4C8D066',
                    li:{
                      background:"#868E961A"
                    }
                  },
                  searchBox: {
                      border: '1px solid #8097ac',
                      'border-radius': '5px'
                  }
              }}
              className={`multi_dropdown_container ${errorClass}`}
              value={userValue?.label}
              onSelect={(e) => onChange(e)}
              onRemove={(e) => onChange(e)}
              name={name}
              options={options}
              displayValue="label"
              id={name}
              placeholder={placeholder}
              disabled={
                  isToggled && userValue?.label && userValue?.label?.length
              }
              showArrow={true}
          ></Multiselect>
      </div>
  );
};

export default DashBoardMultiDropdown;
